module.exports = __webpack_public_path__ + "static/img/item-3-2-big.723e548.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/innovation/item-3-2-big.png
// module id = Ulf8
// module chunks = 2